import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import img1 from "../../../assets/img/home/career/img2.webp";

function WarehouseTwo() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={500}>
      <div className={`warehouseTwo ${isVisible ? "visible" : ""}`}>
        <div className="arrows1">
          <img
            className={`img1 ${isVisible ? "visible" : ""}`}
            src={img1}
            alt=""
            width={"160px"}
          />
          <img
            className={`img2 ${isVisible ? "visible" : ""}`}
            src={img1}
            alt=""
            width={"160px"}
          />
        </div>
        <h1 className={`${isVisible ? "visible" : ""}`}>
          {t("warehouse_two_title")}
        </h1>
        <p className={`${isVisible ? "visible" : ""}`}>
          {t("warehouse_two_text")}
        </p>
        <a className={`${isVisible ? "visible" : ""}`}>
          <button>{t("warehouse_two_btn")}</button>
        </a>
      </div>
    </VisibilitySensor>
  );
}
export default WarehouseTwo;
